const actions = {
  async saveRoute (context, data) {
    context.commit('saveRoute', data)
  }
}

export default actions
